<template>
  <div class="spinner">
    <div class="spinner-child1 spinner-child"></div>
    <div class="spinner-child2 spinner-child"></div>
    <div class="spinner-child3 spinner-child"></div>
    <div class="spinner-child4 spinner-child"></div>
    <div class="spinner-child5 spinner-child"></div>
    <div class="spinner-child6 spinner-child"></div>
    <div class="spinner-child7 spinner-child"></div>
    <div class="spinner-child8 spinner-child"></div>
  </div>
</template>

<script>
export default {
  //
}
</script>

<style scoped>
.spinner {
  margin: 0 auto;
  width: 64px;
  height: 64px;
  position: relative;
}

.spinner .spinner-child {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.spinner .spinner-child::before {
  content: '';
  display: block;
  margin: 0 auto;
  width: 22%;
  height: 22%;
  background-color: theme('colors.blue.500');
  border-radius: 100%;
  animation: animation 0.8s infinite ease-in-out both;
}

.spinner .spinner-child2 {
  transform: rotate(45deg);
}

.spinner .spinner-child3 {
  transform: rotate(90deg);
}

.spinner .spinner-child4 {
  transform: rotate(135deg);
}

.spinner .spinner-child5 {
  transform: rotate(180deg);
}

.spinner .spinner-child6 {
  transform: rotate(225deg);
}

.spinner .spinner-child7 {
  transform: rotate(270deg);
}

.spinner .spinner-child8 {
  transform: rotate(315deg);
}

.spinner .spinner-child2::before {
  animation-delay: -0.7s;
}

.spinner .spinner-child3::before {
  animation-delay: -0.6s;
}

.spinner .spinner-child4::before {
  animation-delay: -0.5s;
}

.spinner .spinner-child5::before {
  animation-delay: -0.4s;
}

.spinner .spinner-child6::before {
  animation-delay: -0.3s;
}

.spinner .spinner-child7::before {
  animation-delay: -0.2s;
}

.spinner .spinner-child8::before {
  animation-delay: -0.1s;
}

@keyframes animation {
  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}
</style>
